import PropTypes from 'prop-types';

export const STYLE_COLOR_CODE_TYPE = PropTypes.shape({
  ruleIds: PropTypes.arrayOf(PropTypes.string)
});

export const STYLE_COLOR_CODES_TYPE = PropTypes.objectOf(STYLE_COLOR_CODE_TYPE);

export const FUNDAMENTAL_RULE_TYPE = PropTypes.shape({
  graphicType: PropTypes.string.isRequired,
  graphicOption: PropTypes.string.isRequired,
  minimumQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  organizationalGraphicUrl: PropTypes.string.isRequired,
  swooshGraphicUrl: PropTypes.string
});

export const FUNDAMENTAL_RULES_TYPE = PropTypes.objectOf(FUNDAMENTAL_RULE_TYPE);

export const FUNDAMENTAL_DATA_TYPE = PropTypes.shape({
  styleColorCodes: STYLE_COLOR_CODES_TYPE,
  rules: FUNDAMENTAL_RULES_TYPE
});
